import {useDispatch} from 'react-redux'
import {AppActions} from 'store/modules/app/actions'

export const useConfirm = () => {
  const dispatchToStore = useDispatch()

  return args => {
    dispatchToStore(AppActions.confirm(args))
  }
}
